export default {
  institution: "profile/institution",
  update: "profile/institution/update",
  remove: "profile/institution/remove",
};
